import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../Table/DetailsTable';
import FeatureSummary from '../../../Util/FeatureSummary';

const CampaignTable = ({ items, loading, editOnClick, createOnClick, deleteOnClick }) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    deleteOnClick={deleteOnClick}
                    id={item.campaignId}
                    item={item}
                />
            ),
        },
        {
            name: 'Slug',
            fieldName: 'slug',
            minWidth: 200,
            maxWidth: 320,
            isResizable: true,
            isSorted: true,
            isSortedDescending: false,
        },
        {
            name: 'Runs Off',
            fieldName: 'dimension',
            minWidth: 100,
            maxWidth: 140,
            isResizable: true,
        },
        {
            name: 'Landing Pages',
            fieldName: 'landingPageCount',
            minWidth: 100,
            maxWidth: 140,
            isResizable: true,
        },
    ];

    const tableItems = items ?? [];

    return (
        <>
            <DetailsTable
                items={tableItems}
                columns={columns}
                loading={loading}
                mainColumn={'slug'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Add' }}
                        text="Add Campaign"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Campaigns"
                summary="This table displays all marketing campaigns. Each campaign has a unique slug and a set of landing page rules that redirect users to different URLs based on either their unit or their persona, optionally narrowed by country. Use Add to create a campaign, or the row menu to edit or delete one."
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'edit',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: 'delete',
                iconProps: { iconName: 'Delete' },
                text: 'Delete',
                onClick: () => deleteOnClick(id, item.slug),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} {...rest} />;
};

export default CampaignTable;
